import { cn } from "@/lib/utils";

export type TagCloudItem = {
  id: string;
  label: string;
  count: number;
  kind: "pain" | "token";
};

export default function TagCloud({
  items,
  className,
}: {
  items: TagCloudItem[];
  className?: string;
}) {
  if (!items.length) {
    return (
      <p className={cn("text-sm text-muted-foreground", className)}>
        Brak tagów w tym oknie.
      </p>
    );
  }

  const max = Math.max(...items.map((i) => i.count), 1);

  return (
    <div
      className={cn(
        "flex flex-wrap items-center justify-center gap-x-3 gap-y-2 py-2",
        className,
      )}
    >
      {items.map((item) => {
        const weight = item.count / max;
        const size = 0.75 + weight * 1.15;
        return (
          <span
            key={`${item.kind}-${item.id}`}
            title={`${item.label}: ${item.count}`}
            className={cn(
              "inline-block leading-tight transition-colors",
              item.kind === "pain"
                ? "font-semibold text-brand"
                : "font-medium text-slate-600",
            )}
            style={{ fontSize: `${size}rem` }}
          >
            {item.label}
            <span className="ml-1 text-[0.65em] font-normal text-muted-foreground">
              {item.count}
            </span>
          </span>
        );
      })}
    </div>
  );
}
